












import {Component, Prop, Vue} from "vue-property-decorator";
import {Card} from "@/types/landing/Card";

@Component
export default class PartnerCard extends Vue {
  @Prop({type: Object, default: () => ({imgSrc: null, title: null, description: null})}) readonly card!: Card;
}
